let options = {
  routersName: [], //路由文件名列表
  menuFlag: "", //显示的功能列表标识
};
if (process.env.PROJECT_NAME === "factory") {
  options.menuFlag = "factory";
  options.routersName = [...require("@/router/factory").default];
} else {
  options.menuFlag = "";
  options.routersName = [...require("@/router/main.js").default];
}

export default options;
